import { FC, ReactElement } from 'react'
import { FrontPage } from './pages/front'
import { AuthProvider } from './contexts/auth.context'

interface FrontProps {
  levelId: string
  sessionId: string
}

export const Front: FC<FrontProps> = (props): ReactElement => (
  <AuthProvider>
    <FrontPage {...props} />
  </AuthProvider>
)
